import api from '@/libs/api';
import { DisbursementManagementResponse } from '@/libs/api.interfaces';
import {
  MutationTree, Module, ActionContext, ActionTree,
} from 'vuex';
import { RootState } from './types';

export type State = {
  loading: boolean;
  revenue: number;
  grossFee: number;
  serviceFee: number;
}

export enum MutationTypes {
  SET_DISBURSEMENT_REVENUE_LOADING = 'SET_DISBURSEMENT_REVENUE_LOADING',
  SET_DISBURSEMENT_REVENUE = 'SET_DISBURSEMENT_REVENUE',
}

const states: State = {
  loading: true,
  revenue: 0,
  grossFee: 0,
  serviceFee: 0,
};

export type Mutations<S = State> = {
  [MutationTypes.SET_DISBURSEMENT_REVENUE_LOADING](state: S, payload: boolean): void;
  [MutationTypes.SET_DISBURSEMENT_REVENUE](state: S, payload: {
    revenue: number;
    grossFee: number;
    serviceFee: number;
  }): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_DISBURSEMENT_REVENUE_LOADING](state, payload) {
    state.loading = payload;
  },
  [MutationTypes.SET_DISBURSEMENT_REVENUE](state, { revenue, grossFee, serviceFee }) {
    state.revenue = revenue;
    state.grossFee = grossFee;
    state.serviceFee = serviceFee;
  },
};

export enum ActionTypes {
  GET_DISBURSEMENT_REVENUE = 'GET_DISBURSEMENT_REVENUE',
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.GET_DISBURSEMENT_REVENUE](
    { commit }: AugmentedActionContext,
    payload: void
  ): Promise<void>;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GET_DISBURSEMENT_REVENUE]({ commit }) {
    try {
      commit(MutationTypes.SET_DISBURSEMENT_REVENUE_LOADING, true);
      const { data } = await api.get<DisbursementManagementResponse>('/disbursement/summary-api/summary/revenue');
      commit(MutationTypes.SET_DISBURSEMENT_REVENUE, {
        revenue: data.revenue,
        grossFee: data.gross_fee,
        serviceFee: data.service_fee,
      });

      commit(MutationTypes.SET_DISBURSEMENT_REVENUE_LOADING, false);
    } catch (err) {
      console.log(err);
    }
  },
};

const disbursementModule: Module<State, RootState> = {
  state: states,
  mutations,
  actions,
};

export default disbursementModule;
